import {
    getItems,
    GetItemsCriteria,
    getPremiumInfo,
    ItemType,
    serverTimestamp,
} from 'helpers/web_to_client'
import moment from 'moment'

export const CLIENT_PRODUCTS_LOAD_REQUEST = 'client/products/REQUEST'
export const CLIENT_PRODUCTS_LOAD_SUCCESS = 'client/products/SUCCESS'
export const CLIENT_PRODUCTS_LOAD_ERROR = 'client/products/ERROR'
export const CLIENT_TIMESTAMP = 'client/timestamp'
export const CLIENT_PREMIUM_LOAD_SUCCESS = 'client/premium/SUCCESS'
export const CLIENT_PREMIUM_LOAD_ERROR = 'client/premium/ERROR'

export function clientProductsRequestStart() {
    return {
        type: CLIENT_PRODUCTS_LOAD_REQUEST,
    }
}

export function clientProductsRequestSuccess(data) {
    return {
        type: CLIENT_PRODUCTS_LOAD_SUCCESS,
        payload: data,
    }
}

export function clientTimestamp(time) {
    return {
        type: CLIENT_TIMESTAMP,
        payload: time,
    }
}

export function clientProductsRequestError(errorData) {
    return {
        type: CLIENT_PRODUCTS_LOAD_ERROR,
        payload: errorData,
    }
}

export function clientPremiumRequestSuccess(data) {
    return {
        type: CLIENT_PREMIUM_LOAD_SUCCESS,
        payload: data,
    }
}

export function clientPremiumRequestError(errorData) {
    return {
        type: CLIENT_PREMIUM_LOAD_ERROR,
        payload: errorData,
    }
}

export function requestClientProducts() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.client.loading) {
            return
        }

        dispatch(clientProductsRequestStart())

        try {
            const deviceFields = ['id', 'images']
            const boosterFields = ['id', 'techName']
            const customizationFields = ['id', 'type']
            const criteria = [GetItemsCriteria.NOT_HIDDEN, GetItemsCriteria.NOT_SECRET]
            const [
                battleboosters, boosters, equipments, devices, crewBooks, inscriptions, emblems,
                camouflages, projections,
            ] = await Promise.all([
                getItems(ItemType.BATTLEBOOSTER, criteria, boosterFields),
                getItems(ItemType.BOOSTER, [], deviceFields),
                getItems(ItemType.EQUIPMENT, [...criteria, GetItemsCriteria.NOT_BUILTIN], deviceFields),
                getItems(ItemType.DEVICE, criteria, deviceFields),
                getItems(ItemType.CREW_BOOKS),
                getItems(ItemType.INSCRIPTION, [], customizationFields),
                getItems(ItemType.EMBLEM, [], customizationFields),
                getItems(ItemType.CAMOUFLAGE, [], customizationFields),
                getItems(ItemType.PROJECTIONDECAL, [], customizationFields),
                dispatch(requestClientPremium()),
            ])

            const products = [
                ...boosters,
                ...equipments,
                ...devices,
                ...crewBooks,
            ].reduce((result, { id, images }) => {
                if (images && images.small) {
                    // save image identifier, e.g. "largeMedkit.png"
                    result[id] = images.small.split('/').pop()
                }
                return result
            }, {})

            // battle boosters has different logic for images
            battleboosters.reduce((result, { id, techName }) => {
                result[id] = `${techName}.png`
                return result
            }, products);

            // customizations has different logic for images
            // cd for customizations is not cd, but id, so they may overlap, so we map them separately
            [
                ...inscriptions,
                ...emblems,
            ].reduce((result, { id, type }) => {
                // save image by customization type
                result[`decal_${id}`] = `${type}.png`
                return result
            }, products);

            // customizations has different logic for images
            [
                ...camouflages,
            ].reduce((result, { id, type }) => {
                // save image by customization type
                result[`camouflage_${id}`] = `${type}.png`
                return result
            }, products);

            // customizations has different logic for images
            [
                ...projections,
            ].reduce((result, { id, type }) => {
                // save image by customization type
                result[`projection_${id}`] = `${type}.png`
                return result
            }, products)
            dispatch(clientProductsRequestSuccess(products))
        } catch (errorData) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH client data parsing error', errorData)
            dispatch(clientProductsRequestError({ errorMessage: errorData.message }))
        }
    }
}

export function requestServerTimestamp() {
    return async (dispatch) => {
        try {
            const serverTime = await serverTimestamp()
            dispatch(clientTimestamp(serverTime || 0))
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH serverTimestamp data parsing error', error)
            dispatch(clientTimestamp(0))
        }
    }
}

export const isPremiumActive = ({ active }) => active

// eslint-disable-next-line no-unused-vars
let premiumExpireTimeoutId = null

export const requestClientPremium = () => {
    return async (dispatch) => {
        try {
            const premiumInfo = await getPremiumInfo()

            // looking for active premium that soon expires
            const expirationDate = [premiumInfo.premium, premiumInfo.premium_vip, premiumInfo.premium_plus]
            .filter(isPremiumActive)
            .map(({ expiryTime }) => expiryTime)
            .sort()
            .shift()

            // check if premium expires less then in 1 hour, so setup delayed request again
            const duration = !!expirationDate && moment.duration(moment.unix(expirationDate).diff(moment()))
            if (duration && duration.asHours() < 1) {
                premiumExpireTimeoutId = setTimeout(() => {
                    dispatch(requestClientPremium())
                }, duration.asMilliseconds() + 1000)
            }

            dispatch(clientPremiumRequestSuccess(premiumInfo))
        } catch (errorData) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request premium info', errorData)
            dispatch(clientPremiumRequestError({ errorMessage: errorData.message }))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/client.js